<template>
  <div class="mod-dial cm-modal" @click="$emit('close')">
    <div class="mod-cont" @click.stop>
      <span class="close-main" @click="$emit('close')"><i class="bi bi-x-lg"></i></span>

      <div class="mod-body cm-result">
        <h3 class="tab-title">{{ $t('CM_IMG_RESULT') }}</h3>

        <div class="cm-result-image" v-if="imageUrl && !previewBroken">
          <img :src="imageUrl" alt="" @error="previewBroken = true" />
        </div>

        <div v-if="loading" class="cm-result-state">{{ $t('CM_IMG_LOADING') }}</div>
        <div v-else-if="error" class="cm-result-state is-error">{{ error }}</div>

        <template v-else-if="item">
          <div class="cm-result-meta">
            {{ item.model }} · tier {{ item.tier }}
            <template v-if="item.escalation"> · {{ item.escalation }}</template>
            <template v-if="item.custom_prompt"> · {{ $t('CM_IMG_PROMPT_CUSTOM') }}</template>
            <template v-if="item.cached"> · {{ $t('CM_IMG_CACHED') }}</template>
            <template v-else-if="item.latency_ms"> · {{ item.latency_ms }} ms</template>
            <template v-if="item.prompt_tokens">
              · {{ item.prompt_tokens }}+{{ item.output_tokens }} tok
            </template>
          </div>

          <dl class="cm-result-fields">
            <template v-for="row in fields">
              <dt :key="row.key + '-k'">{{ row.key }}</dt>
              <dd :key="row.key + '-v'">{{ row.value }}</dd>
            </template>
          </dl>

          <div class="cm-result-actions">
            <button class="btn-st-tr" @click="showJson = !showJson">JSON</button>
            <button class="btn-st-tr" :disabled="loading" @click="$emit('edit-prompt')">
              {{ $t('CM_IMG_PROMPT_EDIT') }}
            </button>
            <button class="btn-st-tr" :disabled="loading" @click="$emit('rerun', {})">
              {{ $t('CM_IMG_RETRY') }}
            </button>
            <button class="btn-st-tr" :disabled="loading" @click="$emit('rerun', { tier: 2 })">
              {{ $t('CM_IMG_TIER2') }}
            </button>
          </div>

          <pre v-if="showJson" class="cm-result-json">{{ json }}</pre>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Результат разбора картинки. Открывается по зелёной галочке на плитке и после
 * очередного разбора; поля показываем как есть — сейчас подбирается их состав.
 */
export default {
  name: "Cm-image-result",
  props: {
    // ответ разбора: с сервера (сохранённый) или только что полученный
    item: { type: Object, default: null },
    imageUrl: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  data() {
    return { showJson: false, previewBroken: false };
  },
  computed: {
    fields() {
      const data = (this.item && this.item.description) || {};
      return Object.keys(data).map((key) => {
        const value = data[key];
        if (Array.isArray(value)) return { key, value: value.map(this.tag).join(", ") || "—" };
        if (value === "" || value == null) return { key, value: "—" };
        return { key, value: String(value) };
      });
    },
    json() {
      return JSON.stringify((this.item && this.item.description) || {}, null, 2);
    },
  },
  methods: {
    /**
     * Элемент ответа строкой. Надписи и бренды приходят объектами: у надписи
     * текст и уверенность, у бренда ещё и то, чем он опознан.
     */
    tag(item) {
      if (!item || typeof item !== "object") return String(item);
      const label = item.text || item.name || JSON.stringify(item);
      const parts = [];
      if (typeof item.confidence === "number") parts.push(item.confidence.toFixed(2));
      if (Array.isArray(item.evidence) && item.evidence.length) parts.push(item.evidence.join("/"));
      return parts.length ? `${label} (${parts.join(", ")})` : String(label);
    },
  },
};
</script>

